/**
 * Created by xiewu on 2016/11/20.
 */
require('fullpage');
var InfoManageVideo=require('./core/videoLinkPlay');
var designIndex=$('#designIndex');
designIndex.addClass('active_one');
//页面主要模块
var pageSection=$('.section');
//浮动导航
var floatNav=$("#floatNav"),
    returnNav=$('.return_top'),
    floatNavLink=$('.page_nav').find('a'),
    sectionNavPoint=$('[data-nav]'),
    navIndexPoint=[];
//生成导航高亮的临界点
sectionNavPoint.each(function(){
    //navIndexPoint.push($(this).index());
    navIndexPoint.push(pageSection.index($(this))+1);
})
//全新色系变量
var designColor=$('#designColor'),//色系块父级
    colorBg=designColor.find('.design_page2_color'),//背景色系
    colorNav=designColor.find('.nav_color'),//颜色导航
    colorImg=designColor.find('.design_page2_img');//色系示范图片
//视频播放
var designAn4=$('#designAni'),
    videoList=designAn4.find('video'),
    videoBtnCon=designAn4.find('.design_page4_explain'),
    videoBtn=designAn4.find('.replay_btn');
//颜色过渡效果
var designNewSpace=$('#designNewSpace'),
    goin=false;
//首屏做一下适配最小高度
indexFix();
function indexFix(){
    var winH=$(window).height();
    if(winH>1000){
        designIndex.height(winH);
    }else{
        designIndex.height(1000);
    }
}
//全屏切换跟踪效果实现
var nowPageIndex;
$('#fullpage').fullpage({
    verticalCentered:false,
    autoScrolling:false,
    resize:false,
    afterLoad:function(anchorLink, index){//anchorLink是锚点 index是当前进入的索引
        nowPageIndex=index;
        setVersibFn(index);
        //设置导航高亮效果
        highlightNav(index);
        //提前加载页面图片
        loadImg(index);
        if(isIe){//如果是IE则不走如下逻辑
            return;
        }
        pageSection.eq(index-1).addClass('active_one');
        switch (pageSection.eq(index-1).attr('id')){
            case 'designAni':
                goin=true;
                break;
            case 'designNew':
                designNewSpace.removeClass('changeColor');
                break;
            case 'designSpace':
                designNewSpace.addClass('changeColor');
                break;
            case 'functionTime':
                if(!isMobile){
                    //时光机
                    videoShow(functionTimeVideo,function(){
                        functionTime.find('.replay_btn').addClass('active');
                    });
                }
                break;
            case 'functionNotice':
                if(!isMobile){
                    //通知管理
                    infoVideo.startPlay();
                }
                break;
            case 'functionMultitask':
                if(!isMobile){
                    //多任务管理
                    videoShow(multitaskVideo,function(){
                        functionMultitask.find('.replay_btn').addClass('active');
                    });
                }
                break;
            case 'safePay':
                if(isMobile){
                    pageSection.eq(index).addClass('active');
                }
                break;
        }
    },
    onLeave:function(index,nextIndex,direction){//index是当前离开的索引,nextIndex是滚动到的“页面”的序号,direction 判断往上滚动还是往下滚动，值是 up 或 down
        if(isIe){//如果是IE则不走如下逻辑
            return;
        }
        switch (pageSection.eq(index-1).attr('id')){
            case 'designAni':
                //全新动画介绍
                videoList.each(function(){
                    videoHide($(this));
                })
                if(goin){
                    videoBtnCon.addClass('active');
                }
                break;
            case 'functionTime':
                if(!isMobile){
                    //时光机
                    videoHide(functionTimeVideo);
                }
                break;
            case 'functionInput':
                if(!isMobile){
                    //输入法
                    videoInputList.each(function(){
                        videoHide($(this));
                    })
                }
                break;
            case 'functionNotice':
                if(!isMobile){
                    //通知管理
                    infoVideo.stopPlay();
                }
                break;
            case 'functionMultitask':
                if(!isMobile){
                    //多任务管理
                    videoHide(multitaskVideo);
                }
                break;
            case 'functionSpare':
                if(!isMobile){
                    //分身术
                    relicationVideo.each(function(){
                        videoHide($(this));
                    })
                }
                break;
            case 'safePay':
                if(isMobile){
                    pageSection.eq(index).removeClass('active_one active');
                }
                break;
        }
    }
});
//隐藏其它无关页面
function setVersibFn(index){
    index -= 1;
    pageSection.each(function(e){
        var eIndex=parseInt(e);
        if(eIndex===index || eIndex===index-1 || eIndex===index+1){
            pageSection.eq(eIndex).removeClass('visible_con');
        }else{
            pageSection.eq(eIndex).addClass('visible_con');
        }
    })
}
//亮亮导航操作
function highlightNav(index){
    for(var i=navIndexPoint.length-1;i>=0;i--){
        if(index>=parseInt(navIndexPoint[i])){
            floatNavLink.eq(i).addClass('active').siblings().removeClass('active');
            break;
        }
    }
}
var showingSection=[];
//图片预加载效果实现
function loadImg(index){
    var nowIndex=index-1,
        section0=pageSection.eq(nowIndex),
        section1=pageSection.eq(nowIndex-1),
        section2=pageSection.eq(nowIndex+1);
        setUrl(section0);
        setUrl(section1);
        setUrl(section2);
}
//动态加载图片
function setUrl(obj){
    if(obj==undefined){
        return;
    }
    var imgCon=obj.find('[data-src]'),
        videoCon=obj.find('[data-video]');
    if(obj.attr('hasSet')!=1){//已经设置过的无需再重复设置src
        obj.attr('hasSet',1);
        imgCon.each(function(){//要设置src的
            $(this).attr({'src':$(this).attr('data-src')});
        })
        if(!isIe && !isMobile){
            videoCon.each(function(){//要设置src的
                $(this).attr({'src':$(this).attr('data-video')});
            })
        }
    }
}
//导航条效果实现
setFloatNav('designTotal');
//点击浮动导航跳转效果
floatNavLink.on('click',function(){
    var gotoIndex=navIndexPoint[$(this).index()];
    loadImg(gotoIndex);
    setTimeout(function(){//先加载好对应地方的图片再跳转
        $('html,body').animate({'scrollTop':pageSection.eq(gotoIndex-1).offset().top},0);
    },150)
})
//返回顶部逻辑
$('.return_top').on('click',function(){
    $('html,body').animate({'scrollTop':0},0);
})
//浮动导航出场交互
function setFloatNav(id){
    var navPoint=$('#'+id).offset().top;
    $(window).on('scroll',function(){
        clearTimeout(this.timer);
        this.timer=setTimeout(function(){
            if($(this).scrollTop()>=navPoint){
                floatNav.addClass('active');
                returnNav.addClass('active');
            }else{
                floatNav.removeClass('active');
                returnNav.removeClass('active');
            }
        },100)
    })
}
//全新交互视频动画逻辑
if(!isIe && !isMobile){
    videoList.each(function(){
        $(this).on('mouseover',function(){
            videoShow($(this));
        })
    })
}
//setDeaignAn();
//全新设计视频播放控制,只有进入视角了才播放
function setDeaignAn(){
    var videoList=$('.design_page4_showcon'),
        videoArr=videoList.find('video'),
        videoPoint=[];
    videoList.each(function(){
        videoPoint.push($(this).offset().top-$(window).height());
    })
    var scrollTimerVideo=null;
    $(window).on('scroll',function(){
        var This=this,
            scrollTopNow;
        if(!scrollTimerVideo && nowPageIndex==5){
            scrollTimerVideo=setTimeout(function(){
                scrollTopNow=$(This).scrollTop();
                if(scrollTopNow>=$('#designSmart').offset().top){
                    return;
                }
                for(var i=0;i<videoPoint.length;i++){
                    if(scrollTopNow>=videoPoint[i]){
                        if(videoArr.eq(i).attr('played')!=1){
                            videoShow(videoArr.eq(i));
                        }
                    }
                }
                scrollTimerVideo=null;
            },200)
        }
    })
}
//色系切换效果实现
var colorClick=false;//阻止用户快速点击
colorNav.on('click','a',function(){
    var indexz=$(this).index();
    if(!colorClick){
        colorClick=true;
        $(this).addClass('active').siblings().removeClass('active');//颜色导航高亮
        colorBg.css('z-index',1).eq(indexz).css('z-index',2).addClass('active');//背景色系切换
        colorImg.eq(indexz).addClass('active').siblings().removeClass('active');//色系示范图片切换
        if(isIe){
            colorClick=false;
            colorBg.eq(indexz).siblings().removeClass('active');//重置其余背景
        }else{
            setTimeout(function(){//动画结束后才可点击
                colorClick=false;
                colorBg.eq(indexz).siblings().removeClass('active');//重置其余背景
            },800)
        }
    }
})

//视频播放
//交互增加视频事件绑定
if(!isMobile && !isIe){
    videoBind(videoList,videoBtnCon);//自动连播实现
    videoReplay(videoBtn,videoList);//播放按钮控制播放
}
//视频事件绑定函数
function videoBind(video,videoBtnCon){//视频播放完了显示播放器按钮
    video.each(function(e){
        this.onended=function(){
            videoBtnCon.eq(e).addClass('active');
            $(this).animate({'opacity':0},400);
        }
    })
}
//视频重播事件绑定函数
function videoReplay(replayBtn,videoArr){//点击重播按钮播放视频
    replayBtn.each(function(e){
        var index=e;
            $(this).on('click',function(){
                videoShow(videoArr.eq(e));
            })
    })
}
//分身术
var replication=$('#functionSpare'),
    relicationVideo=replication.find('video');
if(!isIe && !isMobile){
    //分身术，鼠标移入视频开始播放
    replication.on('mouseover','.function_spare_phone',function(){
        videoShow($(this).find('video'));
    })
}
//时光机
var functionTime=$("#functionTime"),
    functionTimeVideo=functionTime.find('video'),
    functionTimePlay=functionTime.find('.replay_btn');
if(!isIe && !isMobile){
    //时光机重播按钮效果实现
    functionTimePlay.on('click',function(e){
        videoShow(functionTimeVideo);
    })
}
//输入法交互效果
var functionInput=$('#functionInput');
    //输入法视频播放动画效果
var videoInputList=$('.function_input_video');
if(!isIe && !isMobile){
    functionInput.on('mouseover','.function_input_phone',function(){
        var This=this;
        clearTimeout(this.timer);
        this.timer=setTimeout(function(){//当用户鼠标快速移入的时候不做播放，只是有暂停的时候才会触发播放
            videoShow($(This).find('video'));
        },300)
    })
    functionInput.on('mouseout','.function_input_phone',function(){
        clearTimeout(this.timer);
    })
}
//通知管理交互
var infoVideo=null;
if(!isIe && !isMobile){
    infoVideo=new InfoManageVideo({
        sectionId:'#functionNotice'
    });
}
//全新多任务管理
var functionMultitask=$("#functionMultitask"),
    multitaskVideo=functionMultitask.find('video'),
    multitaskPlay=functionMultitask.find('.replay_btn');
multitaskPlay.on('click',function(){
    videoShow(multitaskVideo);
})

//视频播放动作
function videoShow(video,fn){
    video.animate({'opacity':1},400,function(){
        video[0].play();
    });
    video[0].onended=null;
    video[0].onended=function(){
        $(this).animate({'opacity':0},400);
        fn && fn();
    }
}
//视频暂停动作
function videoHide(video,fn){
    video.stop().animate({'opacity':0},400,function(){
        video[0].pause();
        video[0].onended=null;
    });
}
//特殊动画元素处理
if(!isIe){
    setAnimation();
}
function setAnimation(){
    var animationList=$('[data-animate]'),
        scrollTimer=null;
    $(window).on('scroll',function(){
        var nowScrollTop,
            This=this;
        if(!scrollTimer){
            scrollTimer=setTimeout(function(){
                nowScrollTop=$(This).scrollTop();
                animationList.each(function(){
                    if(!$(this).hasClass('active_one') && !$(this).hasClass('active')){
                        if($(this).offset().top<=$(window).height()/2+nowScrollTop){
                            if($(this).attr('data-animate')=='one'){
                                $(this).addClass('active_one');
                            }else{
                                $(this).addClass('active');
                            }
                        }
                    }
                })
                scrollTimer=null;
            },200)
        }
    })
}
//require('./plugins/video/videojs-ie8.min');
//var videojs=require('./plugins/video/video.min');
//require('./plugins/video/video.dev');
require('./plugins/video/video');
//大视频弹窗
var videoNav=$('.js_video_nav'),
    videoDesignWin=$('#videoDesignWin'),
    videoFlyme6Win=$('#videoFlyme6Win'),
    videoDesignCloseBtn=videoDesignWin.find('.close_btn'),
    videoFlyme6CloseBtn=videoFlyme6Win.find('.close_btn'),
    flyme6Video=videojs("videoFlyme6Con"),
    designVideo=videojs("videoDesignCon");
//视频弹窗关闭
videoFlyme6CloseBtn.on('click',function(){
    flyme6Video.pause();
    videoFlyme6Win.hide();
})
videoDesignCloseBtn.on('click',function(){
    designVideo.pause();
    videoDesignWin.hide();
})
//大视频切换
videoNav.each(function(e){
   $(this).on('click',function(){
       if(e===0){
           videoFlyme6Win.show();
           flyme6Video.ready(function(){
               flyme6Video.play();
           })
       }else{
           videoDesignWin.show();
           designVideo.ready(function(){
               designVideo.play();
           })
       }
   })
})
// 加载尾部导航信息
$.getScript('http://www.flyme.cn/static/js/zh/zh_index_footerlink.js', function () {
    var footer_nav = [];
    var footer_length = footerlink.length < 4 ? footerlink.length : 4;
    for (var i = 0; i < footer_length; i++) {
        footer_nav[i] = '<li><a target="_blank" href="' + footerlink[i].url + '">' + footerlink[i].title + '</a></li>';
    }
    $('#footer_nav').prepend(footer_nav.join(''));
});


/*****************
 ** WEBPACK FOOTER
 ** ./js/designChange.js
 ** module id = 0
 ** module chunks = 0
 **/